import { ConfiguredCarCarCode } from '@oneaudi/onegraph-client';
import { TextButton } from '@oneaudi/unified-web-components';
import { forwardRef, useCallback } from 'react';
import { useDialogs } from '~/app/hooks/use-dialogs';
import { NextBestActionProps } from '~/app/pages/summary/components/next-best-actions/components/next-best-action';
import { useGetAudiCode } from '~/graphql/hooks/use-get-audicode';

export const AudiCode = forwardRef<HTMLButtonElement, NextBestActionProps>(({ nba, trackNbaClick }, ref) => {
	const { openDialog } = useDialogs();
	const { getAudiCode, isLoadingAudiCode, shouldDisableButton } = useGetAudiCode();

	const onClickHandler = useCallback(
		(audicode: ConfiguredCarCarCode) => {
			if (!audicode || Object.keys(audicode).length === 0) return;
			trackNbaClick(nba, nba.url, 'button');
			openDialog('audiCode');
		},
		[nba, openDialog, trackNbaClick],
	);

	return (
		<TextButton
			ref={ref}
			id={nba.trackingName}
			variant="secondary"
			aria-label={nba.labelText}
			size={'md'}
			onClick={() => getAudiCode(onClickHandler)}
			icon={'favorite'}
			isLoading={isLoadingAudiCode}
			disabled={shouldDisableButton}
			iconPosition={'leading'}>
			{nba.labelText}
		</TextButton>
	);
});

AudiCode.displayName = 'AudiCode';
